module.exports = __webpack_public_path__ + "static/img/6.205b24c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/downloadImg/6.png
// module id = VruD
// module chunks = 1